var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FF060A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7127 16.0273C28.7284 15.1595 27.3614 13.8375 26.2541 12.9019L26.1857 12.8612C26.0763 12.7799 25.9533 12.7121 25.8234 12.6646C23.1441 12.1901 10.6767 9.97313 10.4375 10.0002C10.3691 10.007 10.3007 10.0341 10.2461 10.068L10.1845 10.1155C10.1094 10.1901 10.0478 10.2782 10.0137 10.3799L10 10.4206V10.6443V10.6782C11.4012 14.3934 16.9445 26.556 18.0382 29.417C18.1065 29.6136 18.2296 29.9797 18.462 30H18.5166C18.6397 30 19.1728 29.3288 19.1728 29.3288C19.1728 29.3288 28.6942 18.3595 29.658 17.1934C29.781 17.051 29.8904 16.8951 29.9861 16.7324C30.0134 16.6036 29.9997 16.4747 29.9519 16.3527C29.904 16.2307 29.8152 16.1154 29.7127 16.0273ZM21.6061 17.3086L25.6662 14.1087L28.0517 16.1968L21.6061 17.3086ZM20.0272 17.0985L13.0348 11.6477L24.3539 13.6341L20.0272 17.0985ZM20.656 18.5222L27.8125 17.4239L19.6308 26.8L20.656 18.5222ZM12.0847 12.1968L19.4462 18.129L18.3799 26.8068L12.0847 12.1968Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/tron.f07aa74326cf6797e7abcf0cb494d757.svg";
export { ForwardRef as ReactComponent };